import React from 'react'
import { withIcon } from '../../withIcon'

function MessageTextSquareIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M7 8.36304H12M7 11.7759H15M9.68375 17.6265H16.2C17.8802 17.6265 18.7202 17.6265 19.362 17.3076C19.9265 17.0272 20.3854 16.5797 20.673 16.0292C21 15.4035 21 14.5843 21 12.946V7.68047C21 6.04215 21 5.22299 20.673 4.59724C20.3854 4.04681 19.9265 3.5993 19.362 3.31884C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.31884C4.07354 3.5993 3.6146 4.04681 3.32698 4.59724C3 5.22299 3 6.04215 3 7.68047V19.9038C3 20.4234 3 20.6832 3.10923 20.8166C3.20422 20.9327 3.34827 21.0002 3.50054 21C3.67563 20.9998 3.88367 20.8375 4.29976 20.5129L6.68521 18.6521C7.17252 18.272 7.41617 18.0819 7.68749 17.9467C7.9282 17.8268 8.18443 17.7392 8.44921 17.6862C8.74767 17.6265 9.0597 17.6265 9.68375 17.6265Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default withIcon(MessageTextSquareIcon)
